import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  PLATFORM_ID,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FlightLocationsInputsComponent } from '../../molecules/flight-locations-inputs/flight-locations-inputs.component';
import { InputRangeComponent } from '../input-range/input-range.component';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { GlobalComponent } from '../../../global';
import { isPlatformBrowser } from '@angular/common';
import { differenceInDays } from 'date-fns';
import { Params } from '../../../../api/api-nmviajes/models/ce-metasearch';

interface Search {
  arrivalLocation: string | null;
  departureLocation: string | null;
  arrivalDate?: string;
  departureDate?: string;
}

@Component({
  selector: 'app-multivuelo',
  templateUrl: './multivuelo.component.html',
  styleUrls: ['./multivuelo.component.scss'],
})
export class MultivueloComponent implements OnInit {
  @ViewChildren(FlightLocationsInputsComponent)
  inputsComponent: QueryList<FlightLocationsInputsComponent>;
  @ViewChildren(InputRangeComponent) datesComponent: QueryList<InputRangeComponent>;

  @Input() params: Params;
  @Output() searchDataMulti = new EventEmitter();

  private readonly now = new Date();
  private readonly minDateDefault: NgbDateStruct = {
    year: this.now.getFullYear(),
    month: this.now.getMonth() + 1,
    day: this.now.getDate(),
  };
  private indexCounter = 0;

  arrayMulti = [{ index: 0, minDate: this.minDateDefault, origin: '' }];
  showDatepicker = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    if (location.href.includes('resultados')) {
      const dataSearch = GlobalComponent.searchData;

      if (dataSearch.multicity) {
        this.arrayMulti = [];
        for (let index = 0; index < dataSearch.multicity.length; index++) {
          const date = dataSearch.multicity[index == 0 ? 0 : index - 1].departureDate.split('-');
          this.arrayMulti.push({
            index,
            minDate:
              index == 0
                ? this.minDateDefault
                : {
                    year: Number(date[0]),
                    month: Number(date[1]),
                    day: Number(date[2]),
                  },
            origin: '',
          });
        }
      }

      if (dataSearch.flightType !== 2 && this.arrayMulti.length === 0) {
        this.arrayMulti = [];
        this.arrayMulti.push({
          index: 0,
          minDate: this.minDateDefault,
          origin: '',
        });
      }

      this.indexCounter = this.arrayMulti.length - 1;
    }
  }

  searchMulti() {
    const arrayData: Search[] = [];
    this.inputsComponent.forEach((component) => {
      arrayData.push(component.getSelectedLocations());
    });
    this.datesComponent.forEach((component, index) => {
      arrayData[index] = { ...arrayData[index], ...component.getValues() };
    });
    return this.searchDataMulti.emit(arrayData);
  }

  addMulti() {
    this.indexCounter++;

    const childrenArray = this.datesComponent.toArray();
    if (childrenArray.length > 0) {
      const lastDate = childrenArray[childrenArray.length - 1].getValues().departureDate;
      const lastDestination = this.inputsComponent.last.getSelectedLocations().arrivalLocation;
      this.arrayMulti.push({
        index: this.indexCounter,
        minDate: lastDate == '' ? this.minDateDefault : this.convertMinDate(lastDate),
        origin: lastDestination ?? '',
      });
    }
  }

  private convertMinDate(date: string): NgbDateStruct {
    const split = date.split('/');
    return { year: Number(split[2]), month: Number(split[1]), day: Number(split[0]) };
  }

  deleteRow(index: number) {
    let prevComponent: InputRangeComponent | null = null;
    this.arrayMulti = this.arrayMulti.filter((item) => item.index !== index);
    this.datesComponent.forEach((component, index) => {
      if (index > 0) {
        const prevMinDate = prevComponent?.idRowMulti;
        const currentMinDate = component.idRowMulti;

        const prevItem = this.arrayMulti.find((item) => item.index === (prevMinDate ?? 0));
        if (!prevItem) return;
        const prevValue = prevItem.minDate;

        const currentItem = this.arrayMulti.find((item) => item.index === currentMinDate);
        if (!currentItem) return;
        const currentValue = currentItem.minDate;

        const prevDate = new Date(prevValue.year, prevValue.month - 1, prevValue.day);
        const currentDate = new Date(currentValue.year, currentValue.month - 1, currentValue.day);

        prevDate.setHours(0, 0, 0, 0);
        currentDate.setHours(0, 0, 0, 0);

        if (differenceInDays(currentDate, prevDate) > 1 && prevComponent) {
          const prevDateStr = prevComponent?.getValues().departureDate;
          this.arrayMulti[component.idRowMulti].minDate = this.convertMinDate(prevDateStr);
        }
      } else {
        this.arrayMulti[0].minDate = this.minDateDefault;
      }
      prevComponent = component;
    });
  }

  openDatepicker($event: boolean) {
    this.showDatepicker = $event;
  }
}
